import Adicionar from './Adicionar';
import Default from './Default';
import Editar from './Editar';

const CategoriasDeCurriculoDefault = Default

export default CategoriasDeCurriculoDefault;
export const CategoriasDeCurriculoAdicionar = Adicionar;
export const CategoriasDeCurriculoEditar = Editar;
